/**
 * KITS UK — Deferred Tracking Library
 * Runs after page load to avoid blocking LCP
 */

(function() {
  'use strict';

  if (!window.ksTrack) return; // guard: global must exist first

  // ============================================================
  // INTERSECTION OBSERVER: Section viewability
  // ============================================================
  if ('IntersectionObserver' in window) {
    var sectionMap = {
      'shopify-section--slideshow': 'hero_video',
      'shopify-section--trust-cards': 'trust_bar',
      'shopify-section--collection-list': 'shop_by_vehicle',
      'shopify-section--featured-collections': 'best_sellers',
      'shopify-section--before-after': 'before_after',
      'shopify-section--media-grid': 'gallery',
      'shopify-section--apps': 'reviews',
      'shopify-section--blog-posts': 'blog',
      'shopify-section--footer': 'footer'
    };

    var sectionObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var cls = entry.target.className || '';
        var sectionKey = 'unknown';
        Object.keys(sectionMap).forEach(function(key) {
          var slug = key.replace('shopify-section--', '');
          if (cls.includes(slug)) sectionKey = sectionMap[key];
        });
        window.ksTrack('section_viewed', {
          section_name: sectionKey,
          section_index: Array.from(document.querySelectorAll('.shopify-section')).indexOf(entry.target)
        });
        sectionObs.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.shopify-section').forEach(function(s) {
      sectionObs.observe(s);
    });
  }

})();
